import {
  ProductRangeCarousel,
  type ProductRangeCarouselItem,
} from '@/components/ui/ProductRangeCarousel/ProductRangeCarousel';
import { cn } from '@/utils/cn';

type ProductSpecializedRangeProps = {
  items: ProductRangeCarouselItem[];
  heading: string;
  subheading: string;
  sectionClassName?: string;
};

export default function ProductSpecializedRange({
  items,
  heading,
  subheading,
  sectionClassName,
}: ProductSpecializedRangeProps) {
  return (
    <section className={cn('overflow-x-clip bg-white', sectionClassName)}>
      <div className="mx-auto mb-8 max-w-5xl px-4 text-center md:mb-10 md:px-6">
        <h2 className="text-3xl font-semibold tracking-tight text-[#0A0A0A] md:text-4xl lg:text-5xl">
          {heading}
        </h2>
        <div
          className="mt-5 text-base leading-relaxed text-gray-600 md:mt-6 md:text-lg"
          dangerouslySetInnerHTML={{ __html: subheading }}
        />
      </div>

      <ProductRangeCarousel items={items} />
    </section>
  );
}
